import React from 'react';
import SiteLinks from './SiteLinks';
import AuthBrand from './AuthBrand';

// The centred card used by the signed-out account screens (forgot / reset password)
const AuthCard = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-black py-10 px-4 sm:px-6">
      <div className="max-w-sm w-full space-y-5 bg-white dark:bg-zinc-900 p-6 sm:p-7 rounded-2xl border border-zinc-200 dark:border-zinc-800 shadow-sm">
        <div>
          <AuthBrand />
          <h1 className="text-center text-lg font-semibold text-zinc-900 dark:text-zinc-100">{title}</h1>
          {subtitle && <p className="text-center text-xs text-zinc-500 dark:text-zinc-400 mt-0.5">{subtitle}</p>}
        </div>
        {children}
      </div>
      <SiteLinks className="mt-5 max-w-sm justify-center" />
    </div>
  );
};

export const authInputClass =
  'appearance-none relative block w-full px-3.5 py-2.5 border border-zinc-200 dark:border-zinc-800 placeholder-zinc-400 dark:placeholder-zinc-500 text-zinc-900 dark:text-zinc-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 text-sm bg-white dark:bg-zinc-900 transition-all shadow-xs';
export const authButtonClass =
  'w-full flex justify-center py-2.5 px-4 text-sm font-semibold rounded-xl text-white dark:text-zinc-900 bg-zinc-900 dark:bg-zinc-100 hover:bg-zinc-800 dark:hover:bg-zinc-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-zinc-900 dark:focus:ring-zinc-100 disabled:opacity-50 transition-all shadow-sm';
export const authErrorClass =
  'flex items-center gap-2 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900/60 text-red-600 dark:text-red-400 px-3.5 py-2.5 rounded-xl text-xs font-medium';

export default AuthCard;
